// THE LEVELS, AREAS & SYSTEMS ROUTE. It used to switch between "Levels & areas" and a
// "3D volumes" view; the 3D volume concept was taken out (owner 2026-11-05: "remove the 3D
// volume concept and keep levels, areas and system as it was before 3D volume"), so there
// is one view again and nothing to switch. Old /volumes and ?view=volumes links land here.
//
// The route stays its own module: CoordinationAreasPage is ~1,900 lines and one more early
// return in it tipped react-hooks/rules-of-hooks into reporting every hook as conditional,
// which failed a production build (2026-11-02).
import React from "react";
import CoordinationAreasPage from "./CoordinationAreasPage";

/** Nothing to switch any more - kept so the page can keep rendering it. */
export default function AreasViewSwitch() {
  return null;
}

/** The route: /areas[/:projectId]. */
export function AreasRoute() {
  return <CoordinationAreasPage />;
}
